export default __webpack_public_path__ + "static/media/DNo.1-2.63148451.jpg";